import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import * as _ from 'lodash';

@Component({
    selector: 'pr-pagination-v2',
    templateUrl: './pr-pagination-v2.component.html',
    styleUrls: ['./pr-pagination-v2.component.scss'],
    standalone: false
})
export class PrPaginationV2Component implements OnInit, OnChanges {
  constructor() {}

  _selectedPage = 1;
  @Output() selectedPageChange = new EventEmitter();
  @Input() get selectedPage() {
    return this._selectedPage;
  }
  set selectedPage(val) {
    this._selectedPage = val;
    this.selectedPageChange.emit(this.selectedPage);
    this.paginateDataList();
  }

  @Output() dataListPaginatedChange = new EventEmitter<any[]>();
  @Input() get dataListPaginated() {
    return this._dataListPaginated;
  }
  set dataListPaginated(val) {
    this._dataListPaginated = val;
    this.dataListPaginatedChange.emit(this.dataListPaginated);
  }
  _dataListPaginated;

  @Input() dataList;
  @Input() itemsPerPage = 10;
  totalPages: number;
  pages;
  moreTreshold = 3;
  _ = _;

  ngOnInit(): void {}

  ngOnChanges(changes: SimpleChanges): void {
    if (!changes['dataList'] || !changes['dataList'].currentValue) return;
    this.totalPages = Math.ceil(
      changes['dataList'].currentValue.length / this.itemsPerPage,
    );

    this.paginateDataList();
  }

  onPrevious() {
    this.selectedPage--;
  }

  onNext() {
    this.selectedPage++;
  }

  paginateDataList() {
    if (!this.dataList) return;
    if (this.dataList.length < this.itemsPerPage) {
      return (this.dataListPaginated = this.dataList);
    }
    let start = (this.selectedPage - 1) * this.itemsPerPage;
    let end = this.selectedPage * this.itemsPerPage;
    this.dataListPaginated = this.dataList.slice(start, end);
  }

  get current() {
    return this.selectedPage - 1;
  }

  get slicedTotalPages() {
    let start = Math.max(this.selectedPage - this.moreTreshold, 1);
    let end = Math.min(this.selectedPage + this.moreTreshold, this.totalPages);

    return _.range(start, end + 1);
  }
  get visiblePages() {
    let start = Math.max(this.selectedPage - 1, 1);
    let end = Math.min(this.selectedPage + 1, this.totalPages);

    return _.range(start, end + 1);
  }

  onFirstPage() {
    this.selectedPage = 1;
  }

  onLastPage() {
    this.selectedPage = this.totalPages;
  }
  onPageClick(page: number) {
    this.selectedPage = page;
  }
}
